import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  CustomDashboardsChartType,
  CustomDashboardsFilterConfig,
  CustomDashboardsInfoChart,
  FilterConfs,
  WidgetKPI,
} from 'emma-common-ts/emma';
import { get, set } from 'lodash';

@Component({
    selector: 'emma-new-widget-modal',
    templateUrl: './emma-new-widget-modal.component.html',
    standalone: false
})
export class EMMANewWidgetModalComponent implements OnInit, OnChanges {
  @Output() save = new EventEmitter<CustomDashboardsInfoChart>();
  @Output() close = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Input() index!: number;
  @Input() kpis!: WidgetKPI[];
  funnelKpis: WidgetKPI[] = [];
  selectedKpis: string[] = [];
  selectedKpi: string | string[] = '';
  @Input() types: CustomDashboardsChartType[] = [];
  @Input() filters: FilterConfs = {};
  @Input() groupBys: CustomDashboardsFilterConfig[] = [];
  @Input() subGroupBys: CustomDashboardsFilterConfig[] = [];

  @Input() widget!: CustomDashboardsInfoChart;

  outputWidget: CustomDashboardsInfoChart | undefined;
  isReallyOpen = false;
  isNew = true;
  /**
   * Prevents groupBy for uninstalls until we have a better solution
   */
  hasUninstalls = false;

  ngOnInit(): void {
    this.updateWidget(this.widget);
    this.isNew = this.widget.type === 'add';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.widget) {
      this.updateWidget(changes.widget.currentValue);
    }
  }

  onChange(key: string, value: string | string[]) {
    if (key === 'kpi' && 'string' === typeof value) {
      value = [value];
    }
    if (get(this.widget, key) !== value) {
      this.widget = set({ ...this.widget, filter: { ...this.widget.filter } }, key, value);
    }
    this.updateWidget(this.widget);
  }
  onSaveButton() {
    if (['lines', 'funnel', 'trapezoid'].indexOf(this.widget.type) === -1) {
      this.widget.kpi = this.widget.kpi.slice(0, 1);
    }
    this.save.emit({ ...this.widget });
  }
  onCancelButton() {
    this.cancel.emit();
  }
  onCloseButton() {
    this.close.emit();
  }

  updateWidget(sourceWidget: CustomDashboardsInfoChart) {
    const widget = { ...sourceWidget };
    if (widget.type === 'lines') {
      widget.groupBy = '';
    } else if (widget.type !== 'lines' && widget.type !== 'funnel' && widget.type !== 'trapezoid') {
      widget.kpi = widget.kpi.slice(0, 1);
    }
    if (widget.type !== 'bars') {
      widget.subGroupBy = '';
    }
    if (typeof widget.kpi === 'string') {
      widget.kpi = [widget.kpi];
    }
    if (widget.type === 'funnel') {
      this.funnelKpis = this.kpis.filter((k) => k.eventKey);
    }

    this.selectedKpis = Array.isArray(widget.kpi) ? widget.kpi : [widget.kpi];
    this.selectedKpi = this.selectedKpis[0];
    // Prevents groupBy for uninstalls until we have a better solution
    this.hasUninstalls = this.selectedKpis.includes('uninstalls') || this.selectedKpi === 'uninstalls';
    if (this.hasUninstalls && widget.groupBy) {
      widget.groupBy = '';
    }
    this.outputWidget = { ...widget, index: undefined };
    this.widget = { ...widget };
  }

  // eslint-disable-next-line class-methods-use-this
  getMultiLabel = (label: string, fem?: boolean) => (values: WidgetKPI[]) => {
    if (values.length > 2) {
      if (fem) {
        return $localize`Seleccionadas ${values.length} ` + label;
      } else {
        return $localize`Seleccionados ${values.length} ` + label;
      }
    }

    return values.map((k) => k.title).join(', ');
  };
}
